import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-generic-picker',
  templateUrl: './generic-picker.component.html',
  styleUrls: ['./generic-picker.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GenericPickerComponent),
      multi: true
    }
  ],
  standalone: false
})
export class GenericPickerComponent implements OnInit, ControlValueAccessor {
  @Input()
  public availableButtons: ButtonDefinition[] = [];
  @Input()
  public buttonText: string = '';
  @Input()
  public buttonIcon: string = '';

  @Input()
  public disableDecrementYear: boolean;
  @Input()
  public disableIncrementYear: boolean;
  @Input()
  public columns: number = 4;
  @Input()
  public isValidOption: (year: number, value: number) => boolean | null;

  @ViewChild('p')
  public popover: NgbPopover;

  public year: number;
  public value: number;

  public disableAll = false;
  private onChange = (_: any) => {};

  public get width() {
    const width = 100 / this.columns;
    return `${width}%`;
  }

  constructor() {}

  ngOnInit(): void {}
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disableAll = isDisabled;
  }

  public writeValue(val: PickerValue): void {
    if (val != null) {
      this.year = val.year;
      this.value = val.value;
    }
  }

  public choose(value: number) {
    this.value = value;
    this.onChange({ value, year: this.year });
    this.popover.close();
  }

  public incrementYear() {
    this.year++;
    const button = this.availableButtons.find(x => x.value === this.value);
    if (button.isValid != null) {
      if (!button.isValid(this.year)) {
        const potentialButtons = this.availableButtons.filter(x => x.value !== this.value);
        potentialButtons.forEach(button => {
          if (button.isValid(this.year)) {
            this.value = button.value;
          }
        });
      }
    }
    this.onChange({ value: this.value, year: this.year });
  }
  public decrementYear() {
    this.year--;
    const button = this.availableButtons.find(x => x.value === this.value);
    if (button.isValid != null) {
      if (!button.isValid(this.year)) {
        const potentialButtons = this.availableButtons
          .filter(x => x.value !== this.value)
          .sort((a, b) => {
            if (a.value > b.value) return -1;
            if (a.value < b.value) return 1;
            return 0;
          });
        potentialButtons.forEach(button => {
          if (button.isValid(this.year)) {
            this.value = button.value;
          }
        });
      }
    }
    this.onChange({ value: this.value, year: this.year });
  }
}

export class ButtonDefinition {
  text: string;
  value: any;
  isDisabled: (any: any) => boolean;
  isValid: (year: number) => boolean;

  public static Build(text: string, value: any, disabled?: (any) => boolean): ButtonDefinition {
    const result = new ButtonDefinition();
    result.value = value;
    result.text = text;
    if (disabled != null) {
      result.isDisabled = disabled;
    } else {
      result.isDisabled = value => false;
    }

    return result;
  }
}

export interface PickerValue {
  year: number;
  value: number;
}
